<template>
    <profile-card :title="form_title">
        <form @submit.prevent="post">
            <div class="acc-setting profile-series-h">
                <div class="logo-upload-crg col-md-12 d-flex">
                    <div class="cp-field cp-ghewsg">
                        <logo v-model="logo"></logo>
                    </div>
                </div>
                <div class="cp-field">
                    <file-pond
                            name="test"
                            ref="pond"
                            v-model="cover"
                            label-idle="Drop cover here..."
                            v-bind:allow-multiple="false"
                            :files="cover"
                            accepted-file-types="image/jpeg, image/png, image/jpg"
                    />
                </div>

            <br>
            <br>
            <br>
            <br>
            <br>
                <div class="form-group" style="padding:20px 10px 5px 20px;">
                    <label for="have_abn" >
                    <input type="checkbox" v-on:change="have_abn_checked()" v-model="have_abn" id="have_abn" style="width:unset;diplay:inline-block"/>
                        
                        <h5 style="display:inline-block">I Have ABN</h5></label>
                </div>

                <div class="cp-field" v-show="have_abn">
                    <h5>ABN Number
                        <span id="abn_ok" style="color:green;display:none" class="fa fa-check"></span>
                        <span id="abn_nok" style="color:red;display:none" class="fa fa-times"></span>
                    </h5>
                    <div class="cpp-fiel">
                        <input
                                type="text"
                                class="form-control"
                                name="abn"
                                placeholder="Enter your ABN number"
                                v-model="abn"
                                v-on:keyup="check_abn_is_valid_and_get_company_name($event)"
                        />
                        <i class="fas fa-pencil-alt"></i>
                    </div>
                    <span id="abn_message"></span>
                <input type="hidden" name="abn_is_valid" v-model="abn_is_valid">
                </div>

                <div class="cp-field">
                    <h5>Business Name</h5>
                    <div class="cpp-fiel">
                        <input
                                type="text"
                                class="form-control"
                                name="first_name"
                                placeholder="Enter your business name"
                                v-model="name"
                        />
                        <i class="fas fa-pencil-alt"></i>
                    </div>
                </div>

              
                <div class="cp-field cp-ffst">
                    <h5>Category</h5>
                    <div class="cpp-fiel">
                        <v-multi-select
                                class="tw-relative tw--top-2px tw-p-1"
                                v-model="category"
                                :options="categories"
                                label="label"
                                track-by="title"
                                placeholder="Select A Category"
                                :clearOnSelect="false"
                                :closeOnSelect="true"
                                :preserveSearch="true"
                                :searchable="true"
                                :loading="categoryLoading"
                                @search-change="searchCategory"
                        />
                    </div>
                </div>

                <div class="cp-field cp-ffst">
                    <h5>Suburb</h5>
                    <div class="cpp-fiel">
                        <v-multi-select
                                class="tw-relative tw--top-2px tw-p-1"
                                v-model="suburb"
                                :options="suburbs"
                                label="label"
                                track-by="title"
                                placeholder="Select A Suburb"
                                :clearOnSelect="false"
                                :closeOnSelect="true"
                                :preserveSearch="true"
                                :searchable="true"
                                :loading="suburbLoading"
                                @search-change="searchSuburb"
                        />
                    </div>
                </div>
                <div class="cp-field cp-kjga" style="margin-bottom: 40px;">
                    <h5>About us</h5>
                    <div class="cpp-fiel">
          <textarea
                  type="text"
                  class="form-control"
                  name="about"
                  placeholder="Write something about you"
                  v-model="about"
          />
                        <i class="fas fa-pencil-alt"></i>
                    </div>
                </div>

                <div class="mt-3">
                    <div
                            style="width: 100%;font-size: 18px;text-transform: capitalize;border-bottom: 1px solid#e5e5e5;padding: 17px 20px;padding-left: 20px;font-weight: 400;color:#2d2c2c;padding-left: 4px;"
                    >Contact info
                    </div>

                    <div style="padding:0 20px;margin-top:15px;">
                        <h5>Phone Number</h5>
                        <div>
                            <v-tel type="text" class="tw-form-input" v-model="phone_number"
                                   :enabledCountryCode="false" :dynamicPlaceholder="true" :inputOptions="{ showDialCode: true}"/>
                        </div>
                    </div>
                    <div class="cp-field">
                        <h5>Website</h5>
                        <div class="cpp-fiel">
                            <input
                                    type="Website"
                                    class="form-control"
                                    name="website"
                                    placeholder="Website url"
                                    v-model="website"
                            />
                            <i class="fas fa-pencil-alt"></i>
                        </div>
                    </div>
                    <div class="save-stngs pd2">
                        <ul>
                            <li>
                                <button class="ps-btn ps-btn--sm" type="submit">Continue</button>
                            </li>
                        </ul>
                    </div>
                    <!--save-stngs end-->
                </div>
            </div>
        </form>
    </profile-card>
</template>

<script>
    // Import Vue FilePond
    import vueFilePond from "vue-filepond";

    // Import FilePond styles
    import "filepond/dist/filepond.min.css";

    // Import FilePond plugins
    // Please note that you need to install these plugins separately

    // Import image preview plugin styles
    import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

    // Import image preview and file type validation plugins
    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import FilePondPluginImagePreview from "filepond-plugin-image-preview";
    import FilePondPluginFileEncode from "filepond-plugin-file-encode";

    // Create component
    const FilePond = vueFilePond(
        FilePondPluginFileValidateType,
        FilePondPluginImagePreview,
        FilePondPluginFileEncode
    );
    import Category from "./Category";
    // import CategorySelector from "./CategorySelector";
    import Suburb from "./Suburb";
    import Logo from "./front/dashboard/profile/Logo";
    import TelInput from "./TelInput";

    export default {
        components: {
            Category,
            // CategorySelector,
            Suburb,
            FilePond,
            Logo,
            TelInput
        },
        props: {
            profile: {
                type: String,
                default: null
            },
            form_title: {
                type: String,
                default: "Trader Profile"
            },
            phone: {
                type: String,
                default: ""
            },
            redirect_url: {
                type: String,
                default: null
            },
            check_abn_is_active: {
                type: String,
                default: '0'
            },
            guid:{
                type: String,
                default: null
            }
        },
        data() {
            return {
                errors: null,
                Profile: {
                    logo: null,
                    max_logo: null,
                    min_logo: null,
                    mid_logo: null,
                    max_cover: null,
                    min_cover: null,
                    cover: null,
                    name: null,
                    category_id: null,
                    suburb_id: null,
                    about: null,
                    phone_number: this.phone,
                    website: null,
                    abn: null,
                },
                logo: null,
                cover: null,
                name: null,
                category_id: null,
                suburb_id: null,
                about: null,
                phone_number: this.phone,
                website: null,
                abn: null,
                categories: [],
                suburbs: [],
                categoryLoading: true,
                suburbLoading: true,
                have_abn: false,
                abn_is_valid: 0,
            };
        },
        computed: {
            category: {
                get() {
                    return _.find(this.categories, item => item.id === this.category_id)
                },
                set(category) {
                    this.category_id = category.id
                }
            },
            suburb: {
                get() {
                    return _.find(this.suburbs, item => item.id === this.suburb_id)
                },
                set(suburb) {
                    this.suburb_id = suburb.id
                }
            }
        },
        created() {
            if (this.profile && this.profile != null && this.profile != undefined) {
                this.Profile = JSON.parse(this.profile);
            }
            this.logo = this.Profile.max_logo;
            this.cover = this.Profile.max_cover;
            this.name = this.Profile.name;
            this.category_id = this.Profile.category_id;
            this.suburb_id = this.Profile.suburb_id;
            this.about = this.Profile.about;
            this.phone_number = this.Profile.phone_number;
            this.website = this.Profile.website;
            this.abn = this.Profile.abn;
            this.searchCategory();
            this.searchSuburb();
        },
        methods: {
            have_abn_checked(){
                if(!this.have_abn){
                    this.abn = null;
                }
            },
            searchCategory(query) {
                let self = this
                self.categoryLoading = true
                axios.get(`/api/v1/search/category`, {
                    params: {query}
                })
                    .then(resp => {
                        self.categoryLoading = false
                        self.categories = resp.data.data
                    })
                    .catch(err => {
                        self.categoryLoading = false
                    })
            },
            check_abn_is_valid_and_get_company_name(event){
                let self = this
                let guid = self.guid
                const abn_value = event.target.value;
                const check_abn_settgin_is_active = self.check_abn_is_active;
                if(check_abn_settgin_is_active == 1){
                    if(abn_value.length === 11){
                        $("input[name='abn']").removeClass('is-invalid');
                        // 74172177893
                        let url = `https://abr.business.gov.au/json/AbnDetails.aspx?abn=${abn_value}&callback=callback&guid=${guid}`;

                        let xhr = new XMLHttpRequest();
                        xhr.open("GET", url);

                        xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            let data = xhr.responseText.replace('callback({','{').replace('})', '}');
                            let obj = JSON.parse(data);
                            console.log(obj);
                            let business_names = obj.EntityName;
                            if(business_names.length > 0){
                                self.name = business_names;
                                $("input[name='first_name']").prop('disabled', true);
                                $("#abn_message").text('ABN is valid').css('color', 'green');
                                $("input[name='abn']").addClass('is-valid');
                                $("#abn_ok").show();
                                $("#abn_nok").hide();
                                self.abn_is_valid = 1;

                            }else{
                                $("input[name='abn']").addClass('is-invalid');
                                $("input[name='first_name']").prop('disabled', false);
                                $("#abn_message").text('ABN is not valid').css('color', 'red');
                                $("#abn_ok").hide();
                                $("#abn_nok").show();
                                self.abn_is_valid = 0;
                            }
                        }};

                        xhr.send();
                    }else{
                        $("input[name='abn']").addClass('is-invalid');
                        $("input[name='first_name']").prop('disabled', false);
                        $("#abn_message").text('ABN is not valid').css('color', 'red');
                        $("#abn_ok").hide();
                        $("#abn_nok").show();
                        self.abn_is_valid = 0;

                    }


                }
                

            },
            searchSuburb(query) {
                let self = this
                self.suburbLoading = true
                axios.get(`/api/v1/search/suburb`, {
                    params: {query}
                }).then(resp => {
                    self.suburbLoading = false
                    self.suburbs = resp.data.data
                })
                    .catch(err => {
                        self.suburbLoading = false
                    })
            },
            post: function () {
                if (!this.logo || this.logo == undefined || this.logo == "") {
                    this.$toast.error("The logo field is required");

                    return;
                }
                let cover = [];
                this.cover.forEach(function (img) {
                    cover.push(img.getFileEncodeDataURL());
                });
                this.$Progress.start();
                let self = this;
                let data = {
                    cover,
                    name: self.name,
                    category_id: self.category_id,
                    suburb_id: self.suburb_id,
                    about: self.about,
                    phone_number: self.phone_number,
                    website: self.website,
                    abn: self.abn,
                    have_abn: self.have_abn,
                    abn_is_valid: self.abn_is_valid,
                };
                axios({
                    method: "post",
                    url: "/api/v1/trader/profile?&api_token=" + window.api_token,
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.$Progress.finish();
                            self.$toast.success(res.data.msg);
                            if (self.redirect_url) {
                                setTimeout(function () {
                                    location.replace(self.redirect_url);
                                }, 2000);
                            }
                        } else {
                            self.$Progress.fail();
                            self.$toast.error(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.$Progress.fail();
                        console.log(err);
                        if (err.response.status == 422) {
                            let errors = err.response.data.data;
                            self.errors = errors;
                            for (let error in errors) {
                                self.$toast.error(errors[error][0]);
                            }
                        }
                    });
            }
        }
    };
</script>


<style scoped>
.is-valid{
    border-color: #28a745;
}
</style>